import { Pipe, PipeTransform } from '@angular/core';
import { User } from '../interfaces/user.interface';
import { getUserFullName } from '../utils/user-name.util';
import { SelectOption } from '@agilox/ui-common';

@Pipe({
	name: 'userSelect',
})
export class UserSelectPipe implements PipeTransform {
	transform(users: User[] | undefined, selectedUsers: User[]): SelectOption<User>[] {
		if (!users) {
			return [];
		}
		users = users.concat(this.findUsersNotInOptions(users, selectedUsers));
		return users?.map((user: User) => ({
			value: user,
			title: `${getUserFullName(user)} (${user.email})`,
		}));
	}

	/**
	 * The options are paginated so it is possible that the selected users are not in the current options.
	 * This method finds the users that are not in the current options and adds them to the options.
	 * @param users
	 * @param selectedUsers
	 * @private
	 */
	private findUsersNotInOptions(users: User[], selectedUsers: User[]): User[] {
		if (!selectedUsers) {
			return [];
		}
		return selectedUsers.filter(
			(selectedUser) => !users.find((User) => User.uuid === selectedUser.uuid)
		);
	}
}
